"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var memory_cache_1 = require("./memory-cache");

var cache = memory_cache_1.memoryCache();

var getRegexInstance = function getRegexInstance(rawRegex) {
  var cachedRegexInstance = cache.get(rawRegex);
  if (cachedRegexInstance) return cachedRegexInstance.value;
  var regexInstance = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(rawRegex, ")"), "i");
  cache.set(rawRegex, {
    value: regexInstance
  });
  return regexInstance;
};

exports.userAgentParser = function (rawRegex, userAgent) {
  // TODO: find out why it fails in some browsers
  try {
    var regexInstance = getRegexInstance(rawRegex);
    var match = regexInstance.exec(userAgent);
    return match ? match.slice(1) : null;
  } catch (_a) {
    return null;
  }
};